if (!customElements.get('collection-load-previous')) {
  customElements.define(
    'collection-load-previous',
    class CollectionLoadPrevious extends HTMLElement {
      constructor() {
        super();
        this.sectionId = document.getElementById('product-grid').dataset.id;
        this.customCollectionGrid = this.closest('custom-collection-grid');
        this.url = this.urlObject = this.currentPageNumber = this.nextPageNumber = this.targetPageNumber = null;

        if (this.button) {
          this.button.addEventListener('click', this.handleButtonClick.bind(this));
          this.init();
        }
      }
      get button() {
        return this.querySelector('a');
      }
      get loadingSpinner() {
        return this.querySelector('.loading__spinner');
      }

      init() {
        this.style.opacity = 1;
      }

      changePageInURL(pageNumber) {
        if (pageNumber == undefined) return;

        let currentUrl = new URL(window.location);
        currentUrl.searchParams.set('page', pageNumber);
        window.history.pushState({}, '', currentUrl);
        //console.log('load prev changepageinurl');
      }

      loadPrevPage() {
        if (this.button == null) return;

        this.url = this.button.href;

        this.button.classList.add('loading');
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove('hidden');
        }

        this.urlObject = new URL(this.url);
        this.currentPageNumber = parseInt(new URLSearchParams(window.location.search).get('page')) || 1;
        this.nextPageNumber = parseInt(this.urlObject.searchParams.get('page'));
        this.targetPageNumber = parseInt(this.currentPageNumber) - 2;
        this.urlObject.searchParams.set('section_id', this.sectionId);
        console.log(this.currentPageNumber, this.nextPageNumber, this.targetPageNumber);

        // console.log(urlObject);
        // console.log(nextPageNumber);
        if (this.nextPageNumber >= 1) {
          this.fetchPage();
        }
      }

      fetchPage() {
        fetch(this.urlObject.toString())
          .then((response) => response.text())
          .then((responseText) => {
            this.changePageInURL(this.nextPageNumber);
            const html = responseText;
            const parsedResponse = new DOMParser().parseFromString(html, 'text/html');
            let productGrid = parsedResponse.getElementById('product-grid');
            this.customCollectionGrid.addToGrid(productGrid, 'prepend');

            if (this.nextPageNumber <= this.targetPageNumber || this.nextPageNumber == 1) {
              console.log('exit loop');
              this.resetButton(parsedResponse);
              if (!facetFiltersForm) {
                const facetFiltersForm = new FacetFiltersForm();
              }
              if (facetFiltersForm) {
                facetFiltersForm.initialColourSelect();
              }
            } else {
              console.log('run another loop');
              this.nextPageNumber--;
              this.urlObject.searchParams.set('page', this.nextPageNumber);
              this.fetchPage();
            }
          });
      }

      resetButton(parsedResponse) {
        const ogLoadMoreButton = document.querySelector('collection-load-previous a');
        const newLoadMoreSection = parsedResponse.querySelector('collection-load-previous');
        if (newLoadMoreSection) {
          let newLoadMoreButton = newLoadMoreSection.querySelector('a');
          ogLoadMoreButton.href = newLoadMoreButton.href;

          this.button.classList.remove('loading');
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.add('hidden');
          }
        } else {
          ogLoadMoreButton.remove();
        }

        if (wishlistCollection) {
          wishlistCollection.updateWishlistButtons();
        }
      }

      handleButtonClick(e) {
        e.preventDefault();
        if (this.children.length == 0) {
          return;
        }
        this.loadPrevPage();
      }
    }
  );
}
